import React, { useEffect, useState,useRef } from "react";
import Sidebar from "../Common/Sidebar";
import Header from "../Common/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Skeleton from "../Components/Skeleton";
import CommonValues from "../Common/utils";
import { Toast } from "primereact/toast";

export default function AgencyInformation() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agencyName, setAgencyName] = useState("");
  const [agencyAddress, setAgencyAddress] = useState("");
  const [agencyCity, setAgencyCity] = useState("");
  const [agencyState, setAgencyState] = useState("");
  const [agencyZip, setAgencyZip] = useState("");
  const [agencyCountry, setAgencyCountry] = useState("");
  const [agencyPhone, setAgencyPhone] = useState("");
  const toast: any = useRef("");

  useEffect(() => {
    getAMSAgencyDetails();
  }, []);

  const onSidebarClick = (val: any) => {
    setSidebarOpen(val);
  };
  const onSubmitClick = () => {
    navigate("/scale");
  };

  const getAMSAgencyDetails = () => {
    setLoading(true);
    var token = localStorage.getItem("igtoken")
    var config = {
      method: "get",
      // url: `${process.env.REACT_APP_MAPSAPI}/api/nowcert/agencyinfo`,
      url: `${process.env.REACT_APP_MAPSAPI}/api/account/agencyinfo`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then((response: any) => {
        setAgencyName(response.data.agencyName);
        setAgencyAddress(response.data.addressLine1);
        setAgencyCity(response.data.city);
        setAgencyState(response.data.state);
        setAgencyZip(response.data.zipCode);
        setAgencyCountry("USA");
        setAgencyPhone(response.data.phone);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.response != null) {
          if (error.response.status == 401) {
            CommonValues.Logout(navigate);
          } 
          else if (error.response.status == 409) {
          } else {
            toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while getting Nowcerts agent details", life: 3000 });
          }
        } else {
          toast.current.show({ severity: "error", summary: 'Error', detail: "Unknown error while getting Nowcerts agent details", life: 3000 });
        }
      });
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
              <Toast ref={toast} />
      
      <Sidebar pagename="agency-information" onSidebarClick={() => onSidebarClick(false)} sidebarOpen={sidebarOpen} />
      {/* Main Content */}
      <main className="flex-1 h-screen overflow-y-auto p-4 md:p-8 ">
        <Header onSidebarClick={() => onSidebarClick(true)} />

        {/* Form Section */}
        <div className="bg-white rounded-lg shadow-md p-6 max-w-3xl mx-auto" style={{ minHeight: "550px" }}>
          <h2 className="text-lg font-bold mb-4">Agency Information</h2>
          
          <div className="space-y-4">
            <div>
              <label className="block font-medium mb-1">Agency Name</label>
              {loading ?
                <Skeleton width="w-full" height="h-10" />
                :
                <input type="text" className="w-full border rounded p-2" value={agencyName} />
              }
            </div>

            <div>
              <label className="block font-medium mb-1">Address</label>
              {loading ?
                <Skeleton width="w-full" height="h-10" />
                :
                <input type="text" placeholder="Street Address" className="w-full border rounded p-2" value={agencyAddress} />
              }
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-medium mb-1">City</label>
                {loading ?
                  <Skeleton width="w-full" height="h-10" />
                  :
                  <input type="text" className="w-full border rounded p-2" value={agencyCity} />
                }
              </div>
              <div>
                <label className="block font-medium mb-1">State/Province</label>
                {loading ?
                  <Skeleton width="w-full" height="h-10" />
                  :
                  <input type="text" className="w-full border rounded p-2" value={agencyState} />
                }
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-medium mb-1">ZIP/Postal Code</label>
                {loading ?
                  <Skeleton width="w-full" height="h-10" />
                  :
                  <input type="text" className="w-full border rounded p-2" value={agencyZip} />
                }
              </div>
              <div>
                <label className="block font-medium mb-1">Country</label>
                {loading ?
                  <Skeleton width="w-full" height="h-10" />
                  :
                  <input type="text" defaultValue="United States" className="w-full border rounded p-2" value={agencyCountry} />
                }
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-medium mb-1">Phone Number</label>
                {loading ?
                  <Skeleton width="w-full" height="h-10" />
                  :
                  <input type="text" className="w-full border rounded p-2" value={agencyPhone} />
                }
              </div>
            </div>

            {loading ?
              <Skeleton width="w-full" height="h-10" />
              :
              <button
                type="submit"
                className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-2 rounded mt-4"
                onClick={onSubmitClick}
              >
                Continue to Diagnostic
              </button>
            }
          </div>
        </div>
      </main>
    </div>
  );
}
